import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import Extras from "./FacebookAdsExtras";

const FacebookAdsCalculator = () => {
  const activeLanguage = useLanguage();
  const ads = activeLanguage.facebookAdsCalculator;
  const [currency, setCurrency] = useState("€");
  const [curselect, setCurselect] = useState(false);

  const [budget, setBudget] = useState({
    tof: 60,
    mof: 15,
    bof: 25,
    aov: 25,
    adSetsTof: 2,
    adSetsMof: 1,
    adSetsBof: 3,
    adTofAdSets: 10,
    adMofAdSets: 1,
    adBofAdSets: 6,
    frequency: 14,
  });

  const {
    tof,
    mof,
    bof,
    aov,
    adSetsTof,
    adSetsMof,
    adSetsBof,
    adTofAdSets,
    adMofAdSets,
    adBofAdSets,
    frequency,
  } = budget;

  let overallD = (
    (adSetsTof * adTofAdSets * aov +
      adSetsMof * adMofAdSets * aov +
      adSetsBof * adBofAdSets * aov) /
    frequency
  ).toFixed(2);
  let overallM = (overallD * 30.4).toFixed(2);
  let tofBD = (overallD * (tof / 100)).toFixed(2);
  let tofBM = (tofBD * 30.4).toFixed(2);
  let mofBD = (overallD * (mof / 100)).toFixed(2);
  let mofBM = (mofBD * 30.4).toFixed(2);
  let bofBD = (overallD * (bof / 100)).toFixed(2);
  let bofBM = (bofBD * 30.4).toFixed(2);
  let percentageSum = tof + mof + bof;

  function handleChange(event) {
    let { name, value } = event.target;
    value = parseInt(value);
    setBudget((prevValue) => ({ ...prevValue, [name]: value }));
  }

  function handleCurselect() {
    setCurselect((prevValue) => !prevValue);
  }

  function changeCurrency(event) {
    let { target } = event;
    setCurrency(target.innerHTML);
    setCurselect(false);
  }

  return (
    <div className="faceads">
      <div className="faceads__main">
        <div className="faceads__side faceads__side--small">
          <h2 className="faceads__header">&#x1F4CD; {ads.col1.p1}</h2>
          <div className="faceads__table-container">
            <div
              className="faceads__warning"
              style={percentageSum === 100 ? { display: "none" } : {}}>
              {ads.warning}
              <b>{percentageSum}%</b>
            </div>
            <div className="faceads__separator">
              <span className="faceads__label">TOF %</span>
              <input
                type="number"
                name="tof"
                value={budget.tof}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
              <span className="faceads__percentage">%</span>
            </div>
            <div className="faceads__separator">
              <span className="faceads__label">MOF %</span>
              <input
                type="number"
                name="mof"
                value={budget.mof}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
              <span className="faceads__percentage">%</span>
            </div>
            <div className="faceads__separator">
              <span className="faceads__label">BOF %</span>
              <input
                type="number"
                name="bof"
                value={budget.bof}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
              <span className="faceads__percentage">%</span>
            </div>
          </div>
          <div className="faceads__table-container">
            <div className="faceads__separator">
              <span className="faceads__label">{ads.col1.p4}</span>
              <input
                type="number"
                name="aov"
                value={budget.aov}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
              <span
                className="faceads__currency faceads__currency__switch"
                onClick={handleCurselect}
                style={curselect ? { backgroundColor: "D6D6D6" } : {}}>
                {currency}
              </span>
              <div
                className="faceads__currency__selector"
                style={curselect ? { display: "flex" } : { display: "none" }}>
                <span
                  className="faceads__currency__unit"
                  onClick={changeCurrency}>
                  €
                </span>
                <span
                  className="faceads__currency__unit"
                  onClick={changeCurrency}>
                  $
                </span>
                <span
                  className="faceads__currency__unit"
                  onClick={changeCurrency}>
                  £
                </span>
              </div>
            </div>
          </div>
          <div className="faceads__table-container">
            <div className="faceads__separator">
              <span className="faceads__label"># TOF Ad Sets</span>
              <input
                type="number"
                name="adSetsTof"
                value={budget.adSetsTof}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
            <div className="faceads__separator">
              <span className="faceads__label"># MOF Ad Sets</span>
              <input
                type="number"
                name="adSetsMof"
                value={budget.adSetsMof}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
            <div className="faceads__separator">
              <span className="faceads__label"># BOF Ad Sets</span>
              <input
                type="number"
                name="adSetsBof"
                value={budget.adSetsBof}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
          </div>
          <div className="faceads__table-container">
            <div className="faceads__separator">
              <span className="faceads__label"># Ads {ads.col1.p2} TOF</span>
              <input
                type="number"
                name="adTofAdSets"
                value={budget.adTofAdSets}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
            <div className="faceads__separator">
              <span className="faceads__label"># Ads {ads.col1.p2} MOF</span>
              <input
                type="number"
                name="adMofAdSets"
                value={budget.adMofAdSets}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
            <div className="faceads__separator">
              <span className="faceads__label"># Ads {ads.col1.p2} BOF</span>
              <input
                type="number"
                name="adBofAdSets"
                value={budget.adBofAdSets}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
          </div>
          <div className="faceads__table-container">
            <div className="faceads__separator">
              <span className="faceads__label">{ads.col1.p3}</span>
              <input
                type="number"
                name="frequency"
                value={budget.frequency}
                onChange={handleChange}
                className="faceads__input"
                placeholder={ads.typeplaceholder}
              />
            </div>
          </div>
        </div>
        {
          // RIGHT SIDE
        }
        <div className="faceads__side faceads__side--large">
          <h2 className="faceads__header">&#128640; Budget</h2>
          <div className="faceads__results">
            <div className="faceads__results__larger">
              <div className="faceads__table-container">
                <div className="faceads__category">Overall Budget</div>
                <div className="faceads__budget faceads__budget--large">
                  <div className="faceads__sub-category faceads__sub-category--large">
                    {ads.col2.p1}
                  </div>
                  <div className="faceads__result faceads__result--large">
                    {overallD}
                    {currency}
                  </div>
                </div>
                <div className="faceads__budget faceads__budget--large">
                  <div className="faceads__sub-category faceads__sub-category--large">
                    {ads.col2.p2}
                  </div>
                  <div className="faceads__result faceads__result--large">
                    {overallM}
                    {currency}
                  </div>
                </div>
              </div>
            </div>

            <div className="faceads__results__smaller">
              <div className="faceads__table-container">
                <div className="faceads__category">TOF Budget</div>
                <div className="faceads__result-block">
                  <div className="faceads__budget">
                    <div className="faceads__sub-category">{ads.col2.p1}</div>
                    <div className="faceads__result">
                      {tofBD}
                      {currency}
                    </div>
                  </div>
                  <div className="faceads__budget">
                    <div className="faceads__sub-category">{ads.col2.p2}</div>
                    <div className="faceads__result">
                      {tofBM}
                      {currency}
                    </div>
                  </div>
                </div>
              </div>
              <div className="faceads__table-container">
                <div className="faceads__category">MOF Budget</div>
                <div className="faceads__result-block">
                  <div className="faceads__budget">
                    <div className="faceads__sub-category">{ads.col2.p1}</div>
                    <div className="faceads__result">
                      {mofBD}
                      {currency}
                    </div>
                  </div>
                  <div className="faceads__budget">
                    <div className="faceads__sub-category">{ads.col2.p2}</div>
                    <div className="faceads__result">
                      {mofBM}
                      {currency}
                    </div>
                  </div>
                </div>
              </div>
              <div className="faceads__table-container">
                <div className="faceads__category">BOF Budget</div>
                <div className="faceads__result-block">
                  <div className="faceads__budget">
                    <div className="faceads__sub-category">{ads.col2.p1}</div>
                    <div className="faceads__result">
                      {bofBD}
                      {currency}
                    </div>
                  </div>
                  <div className="faceads__budget">
                    <div className="faceads__sub-category">{ads.col2.p2}</div>
                    <div className="faceads__result">
                      {bofBM}
                      {currency}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        // EXTRAS
      }
      <Extras />
    </div>
  );
};

export default FacebookAdsCalculator;
